import style from './crypto.module.scss'
import Image from "next/dist/client/image";
import { InView } from 'react-intersection-observer';
import animations from '@styles/animations.module.scss'

const CryptoItem = (props: any) => {
    let { state } = props;
    return (
        <InView triggerOnce={true}>
            {({ inView, ref, entry }) => {
                if (inView) {
                    entry?.target.classList.add(animations.active);
                }
                return (
                    <>
                        <div ref={ref} className={`${style.crypto} ${animations.scroll__animation}`}>
                            <div className={style.crypto__image}>
                                <Image alt={state.alt} height="40px" width="40px" src={state.img} />
                            </div>
                            <div className={style.crypto__name}>
                                <div className={style.crypto__name__title}>
                                    {state.title}
                                </div>
                                <div className={style.crypto__name__subtitle}>
                                    {state.subtitle}
                                </div>
                            </div>
                        </div>
                    </>
                )
            }}
        </InView>
    )
}

export default CryptoItem;
